"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = require("./index");
var _default = exports.default = function _default(callback) {
  var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var checkHigherVesion = (0, _index.checkVesionReplay)();
  if (window.Sentry) {
    callback && callback(window.Sentry, checkHigherVesion);
  } else {
    var sentryUrl = checkHigherVesion && cfg !== null && cfg !== void 0 && cfg.replay ? 'https://s1.zhuanstatic.com/common/system/js/sentry.replay.es6.min.js' : 'https://s1.zhuanstatic.com/common/system/js/sentry.es5.min.js';
    (0, _index.loadJs)(sentryUrl, function () {
      if (window.Sentry) {
        callback && callback(window.Sentry, checkHigherVesion);
      }
    }, false);
  }
};